import "./App.css";
import AllAdmins from "./components/admin/AllAdmins";
import CreateAdmin from "./components/admin/CreateAdmin";
import Dashboard from "./components/admin/Dashboard";
import EditAdmin from "./components/admin/EditAdmin";
import AddQuiz from "./components/admin/exam/AddQuiz";
import AllExam from "./components/admin/exam/AllExam";
import AllPackages from "./components/admin/exam/AllPackages";
import AllQuiz from "./components/admin/exam/AllQuiz";
import CreateExam from "./components/admin/exam/CreateExam";
import CreatePackage from "./components/admin/exam/CreatePackage";
import EditExam from "./components/admin/exam/EditExam";
import EditPackage from "./components/admin/exam/EditPackage";
import EditQuiz from "./components/admin/exam/EditQuiz";
import AllSubjects from "./components/admin/subject/AllSubjects";
import CreateSubject from "./components/admin/subject/CreateSubject";
import EditSubject from "./components/admin/subject/EditSubject";
import AllStudents from "./components/admin/student/AllStudents";
import CreateStudent from "./components/admin/student/CreateStudent";
import Header from "./components/Header";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import EditStudent from "./components/admin/student/EditStudent";
import AddQuestion from "./components/admin/questions-answers/AddQuestion";
import EditQuestion from "./components/admin/questions-answers/EditQuestion";
import AddCourse from "./components/admin/courses/AddCourse";
import Courses from "./components/admin/courses/Courses";
import EditCourse from "./components/admin/courses/EditCourse";
import AddMaterial from './components/admin/material/AddMaterial'
import { AuthProvider } from "./AuthContext";
import { SidebarProvider } from "./context/SidebarContext";
import AdminLogin from "./components/admin/auth/AdminLogin";
import ViewQuestion from "./components/admin/questions-answers/ViewQuestion";
import Login from "./components/student/Login";
import Register from "./components/student/Register";
import StudentProtectedRoute from "./StudentProtectedRoute";
import ProtectedRoute from "./ProtectedRoute";
import AdminUnauthorized from "./components/admin/auth/AdminUnauthorized";
import StudentPage from "./components/student/StudentPage";
import StartExam from "./components/student/StartExam";
import PaymentSuccess from "./components/student/PaymentSuccess";
import PaymentFailed from "./components/student/PaymentFailed";
import Result from "./components/student/Result";
import AdminLogin2 from "./components/admin/auth/AdminLogin2";
import ExamResult from "./components/admin/exam/ExamResult";
import QuestionPaper from "./components/admin/exam/QuestionPaper";
import Mail from "./components/admin/announcement/Mail";
import Banner from "./components/Banner";
import RecommandedCourses from "./components/RecommandedCourses";
import Footer from "./components/Footer";
import SingleCourse from "./components/course/SingleCourse";
import ScrollTop from "./components/utility/ScrollTop";
import XII from "./components/admin/courses/XII";
import XI from "./components/admin/courses/XI";
import XIIPassed from "./components/admin/courses/XIIPassed";
import AboutUs from "./components/AboutUs";
import ContactUs from "./components/ContactUs";
import TermsAndCondition from "./components/TermsAndCondition";
import PaymentDetails from "./components/admin/PaymentDetails";
import StudentEdit from "./components/student/StudentEdit";
import PrivacyPolicy from "./components/PrivacyPolicy";
import StudentUnauthorized from "./components/student/StudentUnauthorized";
import Solution from "./components/admin/exam/Solution";
import ViewSolution from "./components/student/ViewSolution";
import ViewStudentsDetails from "./components/admin/student/ViewStudentsDetails";
import CommonMail from "./components/admin/announcement/CommonMail";
import ForgotPassword from "./components/student/ForgotPassword";
import ResetPassword from "./components/student/ResetPassword";
import AllInquiries from "./components/admin/AllInquiries";
import NotFound from "./NotFound";
import { useEffect } from "react";
import ClassXIIMaterial from "./components/admin/material/ClassXIIMaterial";
import ClassXIIPassedMaterial from "./components/admin/material/ClassXIIPassedMaterial";
import SingleMaterial from "./components/admin/material/SingleMaterial";
import ReviewExam from "./components/student/ReviewExam";
import ResultTPT from "./components/student/ResultTPT";
import TPTExamResult from "./components/admin/exam/TPTExamResult";
import TPTReviewExam from "./components/student/TPTReviewExam";
import Materials from "./components/admin/material/Materials";
import EditMaterial from "./components/admin/material/EditMaterial";
import Blogs from "./components/blog/Blogs";
import AdminBlogs from "./components/admin/blog/AdminBlogs";
import AddBlog from "./components/admin/blog/AddBlog";
import Blog from "./components/blog/Blog";
import EditBlog from "./components/admin/blog/EditBlog";
import { ToastContainer } from "react-toastify";
import Testimonials from "./components/Testimonials";
import AddTestimonial from "./components/admin/testimonial/AddTestimonial";
import AdminTestimonials from "./components/admin/testimonial/AdminTestimonials";
import EditTestimonial from "./components/admin/testimonial/EditTestimonial";
import AdminGallery from "./components/admin/gallery/AdminGallery";
import AddGallery from "./components/admin/gallery/AddGallery";
import EditGallery from "./components/admin/gallery/EditGallery";
import Gallery from "./components/Gallery";
import MockTest from "./components/mock-test/MockTest";
import AdWithCountdown from './components/AdWithCountdown'
import HomeModal from "./components/modal/HomeModal";
import MarqueeSlider from "./components/slider/MarqueeSlider";
import LeftCampaign from "./components/fixed/LeftCampain";
import CreateTopic from "./components/admin/topic/CreateTopic";
import AllTopic from "./components/admin/topic/AllTopic";
import GenerateExam from "./components/student/dynamic-exam/GenerateExam";
import DynamicExam from "./components/student/dynamic-exam/DynamicExam";
import AllQuestionsExamwise from "./components/admin/questions-answers/AllQuestionsExamwise";
import AllQuestionsTopicwise from "./components/admin/questions-answers/AllQuestionsTopicwise";
import ResultTWP from "./components/student/ResultTWP";
import TWPReviewExam from "./components/student/TWPReviewExam";
import TWPQuestionPaper from "./components/student/TWPQuestionPaper";
import TWPSolution from "./components/student/TWPSolution";
import GenerateNeetFlexi from "./components/student/GenerateNeetFlexi.js";

function App() {
  useEffect(() => {
    // Initialize Bootstrap tooltips manually using JavaScript (required for Bootstrap 5)
    const tooltipTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new window.bootstrap.Tooltip(tooltipTriggerEl);
    });
  }, []);
  return (
    <AuthProvider>
      <SidebarProvider>
        <Router>
          <ToastContainer position="top-right" autoClose={4000}/>
          <ScrollTop />
          <div className="App">
            <Routes>
              <Route path='/ad' element={<AdWithCountdown/>}/>
              <Route exact path="/" element={<>
                {/* <MathMLExtracter/> */}
                <HomeModal/>
                <Header />
                <MarqueeSlider/>
                <LeftCampaign/>
                <Banner />
                <RecommandedCourses />
                <Footer />
              </>} />
              <Route path="/course/:courseID" element={<><Header /><SingleCourse /><Footer /></>} />
              <Route path="/courses/Class XI" element={<><Header /><XI /><Footer /></>} />
              <Route path="/courses/Class XII" element={<><Header /><XII /><Footer /></>} />
              <Route path="/courses/Class XII Passed" element={<><Header /><XIIPassed /><Footer /></>} />

              <Route path="/materials/Class XII" element={<><Header /><ClassXIIMaterial /><Footer /></>} />
              <Route path="/materials/Class XII Passed" element={<><Header /><ClassXIIPassedMaterial /><Footer /></>} />
              <Route path="/material/:materialID" element={<><Header /><SingleMaterial /><Footer /></>} />

              <Route path='/blogs' element={<><Header/><LeftCampaign/><Blogs/><Footer/></>} />
              <Route path='/blog/:id' element={<><Header/><LeftCampaign/><Blog/><Footer/></>} />

              <Route path='/testimonials' element={<><Header/><LeftCampaign/><Testimonials/><Footer/></>} />
              <Route path='/gallery' element={<><Header/><LeftCampaign/><Gallery/><Footer/></>} />

              <Route path='/about-us' element={<><Header /><LeftCampaign/><AboutUs /><Footer /></>} />
              <Route path='/contact-us' element={<><Header /><LeftCampaign/><ContactUs /><Footer /></>} />
              <Route path='/terms-and-condition' element={<><Header /><LeftCampaign/><TermsAndCondition /><Footer /></>} />
              <Route path='/privacy-policy' element={<><Header /><LeftCampaign/><PrivacyPolicy /><Footer /></>} />


              <Route path="/register" element={<><Header /><Register /><Footer /></>} />
              <Route path="student/:email/edit" element={<><Header /><StudentEdit /><Footer /></>} />
              <Route path="/unauthorized" element={<><Header /><StudentUnauthorized /><Footer /></>} />
              <Route path="/login" element={<><Header /><Login /><Footer /></>} />
              <Route path="/forgot-password" element={<><Header /><ForgotPassword /><Footer /></>} />
              <Route path="/reset-password/:token" element={<><Header /><ResetPassword /><Footer /></>} />
              <Route path="/student/:id" element={<StudentProtectedRoute role='student'><Header /><StudentPage /><Footer /></StudentProtectedRoute>} />
              <Route path="/student/:email/exam/:examId" element={<StartExam />} />
              <Route path="/payment-success" element={<PaymentSuccess />} />
              <Route path="/payment-failure" element={<PaymentFailed />} />
              <Route path='/exam/results/:email/:examId' element={<Result />} />
              <Route path='/exam/tpt-results/:email/:examId' element={<ResultTPT />} />
              <Route path='/dynamic-exam/result/:examId' element={<ResultTWP />} />
              <Route path='/dynamic-exam/twp/question-paper/:examId' element={<><Header /><TWPQuestionPaper /><Footer /></>} />
              <Route path='/dynamic-exam/twp/solution/:examId' element={<><Header /><TWPSolution /><Footer /></>} />
              <Route path='/exam/review/:email/:examId' element={<><Header/><ReviewExam /><Footer/></>} />
              <Route path='/exam/tpt-review/:email/:examId' element={<><Header/><TPTReviewExam /><Footer/></>} />
              <Route path='/dynamic-exam/twp/review/:examId' element={<><Header/><TWPReviewExam /><Footer/></>} />
              <Route path='/view-solution' element={<><Header /><ViewSolution /><Footer /></>} />

              <Route path='/generate-exam' element={<ProtectedRoute roles={['student']}><Header /><GenerateExam /><Footer /></ProtectedRoute>} />
              <Route path='/generate-neet-flexi' element={<ProtectedRoute roles={['student']}><Header /><GenerateNeetFlexi /><Footer /></ProtectedRoute>} />
              <Route path="/dynamic-exam/:examId" element={<DynamicExam />} />

              <Route path='/view-material' element={<><Header /><ViewSolution /><Footer /></>} />

              <Route path='/mock-test' element={<><Header /><LeftCampaign/><MockTest /><Footer /></>} />

              <Route path="/admin/unauthorized" element={<AdminUnauthorized />} />
              <Route path="/admin/login" element={<AdminLogin2 />} />
              <Route path="/admin/dashboard" element={
                <ProtectedRoute roles={['superadmin', 'admin']}>
                  <Dashboard />
                </ProtectedRoute>
              }
              />
              <Route path="/admin/create" element={
                <ProtectedRoute roles={['superadmin']}>
                  <CreateAdmin />
                </ProtectedRoute>

              } />
              <Route path="/admins" element={
                <ProtectedRoute roles={['superadmin']}>
                  <AllAdmins />
                </ProtectedRoute>
              } />
              <Route path="/admin/edit/:id" element={<ProtectedRoute roles={['superadmin']}><EditAdmin /></ProtectedRoute>} />

              <Route path="/admin/exam/package/create" element={<ProtectedRoute><CreatePackage /></ProtectedRoute>} />
              <Route path="/admin/exam/package/edit/:id" element={<ProtectedRoute><EditPackage /></ProtectedRoute>} />
              <Route path="/admin/exams/packages" element={<ProtectedRoute><AllPackages /></ProtectedRoute>} />

              <Route path="/admin/exams/create" element={<ProtectedRoute roles={['superadmin', 'admin']}><CreateExam /></ProtectedRoute>} />
              <Route path="/admin/exams" element={<ProtectedRoute roles={['superadmin', 'admin']}><AllExam /></ProtectedRoute>} />
              <Route path="/exam/edit/:id" element={<ProtectedRoute roles={['superadmin', 'admin']}><EditExam /></ProtectedRoute>} />
              <Route path="/exam/result/:id" element={<ProtectedRoute roles={['superadmin', 'admin']}><ExamResult /></ProtectedRoute>} />
              <Route path="/exam/tpt/result/:id" element={<ProtectedRoute roles={['superadmin', 'admin']}><TPTExamResult /></ProtectedRoute>} />
              <Route path="/admin/exam/question-paper/:id" element={<ProtectedRoute roles={['superadmin', 'admin']}><QuestionPaper /></ProtectedRoute>} />
              <Route path="/admin/exam/solution/:id" element={<ProtectedRoute roles={['superadmin', 'admin']}><Solution /></ProtectedRoute>} />

              <Route path="/admin/topic/create" element={<ProtectedRoute roles={['superadmin', 'admin']}><CreateTopic /></ProtectedRoute>} />
              <Route path="/admin/topics" element={<ProtectedRoute roles={['superadmin', 'admin']}><AllTopic /></ProtectedRoute>} />

              <Route path="/admin/exams/quiz/create" element={<AddQuiz />} />
              <Route path="/admin/exams/quiz/all" element={<AllQuiz />} />
              <Route path="/admin/exam/quiz/edit/:id" element={<EditQuiz />} />

              <Route path="/admin/announcement/mail" element={<ProtectedRoute roles={['superadmin', 'admin']}><Mail /></ProtectedRoute>} />
              <Route path="/admin/announcement/common-mail" element={<ProtectedRoute roles={['superadmin', 'admin']}><CommonMail /></ProtectedRoute>} />

              <Route path="/admin/subject/create" element={<ProtectedRoute roles={['superadmin', 'admin']}><CreateSubject /></ProtectedRoute>} />
              <Route path="/admin/subjects" element={<ProtectedRoute roles={['superadmin', 'admin']}><AllSubjects /></ProtectedRoute>} />
              <Route path="/admin/subject/edit/:id" element={<ProtectedRoute roles={['superadmin', 'admin']}><EditSubject /></ProtectedRoute>} />

              <Route path="/admin/students" element={
                <ProtectedRoute roles={['superadmin']}>
                  <AllStudents />
                </ProtectedRoute>
              } />
              <Route path="/admin/students/view-details" element={
                <ProtectedRoute roles={['superadmin', 'admin']}>
                  <ViewStudentsDetails />
                </ProtectedRoute>
              } />
              <Route path="/admin/student/register" element={
                <ProtectedRoute roles={['superadmin']}>
                  <CreateStudent />
                </ProtectedRoute>
              } />
              <Route path="/student/edit/:id" element={<ProtectedRoute roles={['superadmin']}><EditStudent /></ProtectedRoute>} />

              <Route path="/admin/question/add" element={<ProtectedRoute roles={['superadmin', 'admin']}><AddQuestion /></ProtectedRoute>} />
              <Route path="/admin/questions/examwise" element={<ProtectedRoute roles={['superadmin', 'admin']}><AllQuestionsExamwise /></ProtectedRoute>} />
              <Route path="/admin/questions/topicwise" element={<ProtectedRoute roles={['superadmin', 'admin']}><AllQuestionsTopicwise /></ProtectedRoute>} />
              <Route path="/admin/question/view/:id" element={<ProtectedRoute roles={['superadmin', 'admin']}><ViewQuestion /></ProtectedRoute>} />
              <Route path="/admin/question/edit/:id" element={<ProtectedRoute roles={['superadmin', 'admin']}><EditQuestion /></ProtectedRoute>} />

              <Route path="/admin/course/add" element={<ProtectedRoute roles={['superadmin']}><AddCourse /></ProtectedRoute>} />
              <Route path="/admin/courses" element={<ProtectedRoute roles={['superadmin']}><Courses /></ProtectedRoute>} />
              <Route path="/admin/course/edit/:id" element={<ProtectedRoute roles={['superadmin']}><EditCourse /></ProtectedRoute>} />

              <Route path="/admin/material/add" element={<ProtectedRoute roles={['superadmin']}><AddMaterial /></ProtectedRoute>} />
              <Route path="/admin/materials" element={<ProtectedRoute roles={['superadmin']}><Materials /></ProtectedRoute>} />
              <Route path="/admin/material/edit/:id" element={<ProtectedRoute roles={['superadmin']}><EditMaterial /></ProtectedRoute>} />

              <Route path="/admin/payment-details" element={<ProtectedRoute roles={['superadmin']}><PaymentDetails /></ProtectedRoute>} />
              <Route path="/admin/inquires" element={<ProtectedRoute roles={['superadmin', 'admin']}><AllInquiries /></ProtectedRoute>} />

              <Route path='/admin/blogs' element={<ProtectedRoute roles={['superadmin']}><AdminBlogs /></ProtectedRoute>} />
              <Route path='/admin/blogs/add' element={<ProtectedRoute roles={['superadmin']}><AddBlog /></ProtectedRoute>} />
              <Route path='/admin/blogs/edit/:id' element={<ProtectedRoute roles={['superadmin']}><EditBlog /></ProtectedRoute>} />

              <Route path='/admin/testimonials/add' element={<ProtectedRoute roles={['superadmin']}><AddTestimonial /></ProtectedRoute>} />
              <Route path='/admin/testimonials/edit/:id' element={<ProtectedRoute roles={['superadmin']}><EditTestimonial /></ProtectedRoute>} />
              <Route path='/admin/testimonials' element={<ProtectedRoute roles={['superadmin']}><AdminTestimonials /></ProtectedRoute>} />

              <Route path='/admin/gallery' element={<ProtectedRoute roles={['superadmin']}><AdminGallery /></ProtectedRoute>} />
              <Route path='/admin/gallery/add' element={<ProtectedRoute roles={['superadmin']}><AddGallery /></ProtectedRoute>} />
              <Route path='/admin/gallery/edit/:id' element={<ProtectedRoute roles={['superadmin']}><EditGallery /></ProtectedRoute>} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            <div className="fixed-btm-top">
              <span onClick={() => window.scrollTo(0, 0)} className="js-scroll-trigger scroll-to-top"><i className="fa fa-angle-up"></i></span>
            </div>
          </div>
        </Router>
      </SidebarProvider>
    </AuthProvider>
  );
}

export default App;
